import React from 'react';
import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { useStyletron } from 'styletron-react';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './formConfig';
import useRefundDetails from './useRefundDetails';

const RefundDetails: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useRefundDetails();
	const [css] = useStyletron();
	return (
		<div>
			<h3
				className={css({
					textAlign: 'center',
					marginTop: '20px',
					marginBottom: '20px'
				})}>
				Please enter details to create refund request
			</h3>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Back'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default RefundDetails;
